import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // "0, 0" means x=0, y=0 (Top left corner)
    window.scrollTo(0, 0);
  }, [pathname]); // Runs every time the route path changes

  return null; // This component doesn't render anything visually
};

export default ScrollToTop;